import { withAITracking } from "@microsoft/applicationinsights-react-js";
import awsdk from "awsdk";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { RouteComponentProps } from "react-router";

import { Button, Text } from "/component/base";
import MainContent from "/component/layout/MainContent";
import TelehealthDependentAddModal from "/component/modal/TelehealthDependentAddModal";
import CaregiverCard from "/component/partial/CaregiverCard";
import routes from "/constant/url.constant";
import { useAmwell, useTranslation } from "/hook";
import { useAnalytics } from "/hook/useAnalytics/useAnalytics";
import { layout } from "/styles";
import { reactPlugin } from "/util/appInsights.util";

import { ButtonContainer, ContentContainer, Title } from "./TelehealthPatientSelection.styles";

const TelehealthPatientSelection = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation("telehealth");
  const { recordAnalyticsEvent } = useAnalytics();
  const { dependents, updateConsumer, parentConsumer } = useAmwell();
  const [dependentModalOpen, setDependentModalOpen] = useState(false);

  useEffect(() => {
    recordAnalyticsEvent("viewAmwellIntro");
  }, [recordAnalyticsEvent]);

  const switchMyAccount = () => {
    if (parentConsumer) {
      updateConsumer(parentConsumer);
      history.push(routes.telehealthProviders);
    }
  };

  const switchCaregiver = async (dependent: awsdk.AWSDKConsumer) => {
    recordAnalyticsEvent("amwellSelectDependent");
    updateConsumer(dependent);
    history.push(routes.telehealthProviders);
  };

  return (
    <MainContent parentPage="root">
      <Helmet>
        <title>{t("patientSelection.helmetTitle")}</title>
      </Helmet>

      <Title>{t("patientSelection.title")}</Title>

      <ContentContainer>
        <Text css={layout.margin("skip", "skip", "condensed", "skip")} variant="body1Bold">
          {t("patientSelection.myself")}
        </Text>
        <CaregiverCard
          name={{
            firstName: parentConsumer?.firstName || "",
            lastName: parentConsumer?.lastName || "",
          }}
          dob={new Date(parentConsumer?.dob || "")}
          onClick={() => switchMyAccount()}
        />

        {dependents && dependents?.length > 0 ? (
          <Text css={layout.margin("skip", "skip", "condensed", "skip")} variant="body1Bold">
            {t("patientSelection.myChild")}
          </Text>
        ) : null}
        {dependents?.map((d) => (
          <CaregiverCard
            name={{ firstName: d.firstName, lastName: d.lastName }}
            dob={d.dob}
            onClick={() => switchCaregiver(d)}
          />
        ))}
      </ContentContainer>

      <ButtonContainer>
        <Button
          onClick={() => {
            recordAnalyticsEvent("amwellAddDependent");
            setDependentModalOpen(true);
          }}
          variant="secondary"
        >
          {t("patientSelection.button.addChild")}
        </Button>
      </ButtonContainer>

      <TelehealthDependentAddModal
        isOpen={dependentModalOpen}
        close={() => setDependentModalOpen(false)}
      />
    </MainContent>
  );
};

export default withAITracking(reactPlugin, TelehealthPatientSelection, undefined, "ai-tracking");
